import { v4 as uuidv4 } from 'uuid';

export function StackLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'StackLayout',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
